<template>
  <div class="comp-home">
    <vip-level :iconType="1" :curData="compDetail"></vip-level>
    <div class="header-title">
      <comp-icon
        class="comp-logo"
        :src="compDetail.CompLogo"
        :width="140"
        :height="42"
      ></comp-icon>
      <tab :compId="compId"></tab>
      <div class="search-input">
        <el-input
          v-model="input"
          size="small"
          placeholder="输入你想搜索的产品"
          @change="companySearch"
        >
          <template slot="prepend"><i class="el-icon-search"></i></template>
        </el-input>
      </div>
    </div>
    <div
      class="comp-banner"
    >
      <img :src="compMainBanner" alt="">
    </div>
    <div class="quick-click">
      <div class="quick-click-button" @click="goPorducyList">
        <img :src="EnterIcon" alt="" style="width: 45px" />
        <span>产品入口</span>
        <el-button @click="goPorducyList" size="small">点击进入</el-button>
      </div>
      <div v-show="showClassify">
        <el-divider
          direction="vertical"
        ></el-divider>
      </div>
      <div class="quick-click-button"  v-show="showClassify">
        <img :src="ClassifyIcon" alt="" style="width: 47px" />
        <span>分类选型</span>
        <el-button @click="goLecto" size="small">点击进入</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { ApiService, CompService, AuthService, OpenService, UserService } from "@/service";
import CompIcon from "@/components/icon/comp-icon.vue";
import Tab from "./components/tab.vue";
import VipLevel from "@/components/icon/vip-level.vue";

const EnterIcon = require('@/assets/images/comp/comp-enter.png');
const ClassifyIcon = require('@/assets/images/comp/classify-selection.png');

export default {
  components: {
    CompIcon,
    Tab,
    VipLevel,
  },
  data() {
    return {
      compId: 0,
      compDetail: {},
      input: "",

      EnterIcon,
      ClassifyIcon,
      compMainBanner:'',
    };
  },
  computed: {
    // compMainBanner() {
    //   return CompService.getCompMainBanner(this.compId);
    // },
    // 是否显示分类选型
    showClassify(){
      return AuthService.getLectoByCompid(this.compId)
    },
  },
  methods: {
    async getCompInfo() {
      const res = await CompService.getCompanyInfo(this.compId);
      if (res.code === 0) {
        this.compDetail = res.data;
        document.title = res.data.CompName;
        this.compMainBanner = `${ApiService.ImageHost}${res.data.CompanyBanner}`;
        // const status = (res.data.info && res.data.info.status === 0) ? 0 : 1;
        // if (status == 0) {
        //     window.location.replace(`${location.origin}/exception/vipexpire/${this.compId}`)
        //     return false;
        // }

        const compState = Number(res.data.state);
        if (compState == 9) {
          window.location.replace(`${location.origin}/exception/vipexpire/${this.compId}`)
          return false;
        }
      }
    },
    goPorducyList(){
      this.$router.push(`/product/list/${this.compId}`);
    },
    goLecto(){
      this.$router.push(`/company/lecto/${this.compId}`);
    },
    companySearch() {
      if (!this.input) return;
      OpenService.openSearchLib(this.input, true, `?compId=${this.compDetail.CompID}&compName=${this.compDetail.CompName}`);
    }
  },
  mounted() {
    this.compId = this.$route.params.id;
    this.getCompInfo();

    UserService.viewLogs('Comp', this.compId);
  },
  beforeRouteUpdate(to, from) {
    if (to.fullPath !== from.fullPath) {
      this.compId = to.params.id;
      this.getCompInfo();
    }
  },
};
</script>
<style lang="less" scoped>
.comp-home {
  background-color: #ffffff;
  position: relative;

  /deep/ .vip-level{
    position: absolute;
    left: 50%;
    margin-left: -470px;
    top: 48px;
    z-index: 99;
  }

  .header-title {
    height: 50px;
    position: relative;
  }
  .search-input {
    width: 166px;
    height: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    right: 30px;
    top: 0;
    /deep/ .el-input-group__prepend{
      padding: 0 10px;
      background: none;
      border: 0 none;
    }
    /deep/ input{
      border: 0 none;
      padding-left: 0;
    }
  }
}

.header-title,
.tab {
  display: flex;
  align-items: center;
  justify-content: center;
}

.comp-icon {
  width: 140px;
  height: 42px;
  margin-right: 50px;
}

.comp-banner {
  width: 100%;
  img{
    width: 100%;
  }
}

.quick-click {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  /deep/ .el-divider{
    height: 105px;
    margin: 0 106px;
  }

  &-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      height: 44px;
    }

    span {
      font-size: 20px;
      color: #8d8d8d;
      margin: 20px 0;
    }
  }
}
</style>